export const Events = [
    {
        allDay: false,
        start: new Date("September 16, 2022 10:00"),
        end: new Date("October 16, 2022"),
        title: "Coat Collection",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 29, 2022 10:00"),
        end: new Date("October 29, 2022"),
        title: "Fall Coat Distribution",
        location: "",
    },
    {
        allDay: false,
        start: new Date("November 4, 2022 10:00"),
        end: new Date("November 4, 2022"),
        title: "MLK High PTSA Community Partner",
        location: "",
    },
    {
        allDay: false,
        start: new Date("November 1, 2022 10:00"),
        end: new Date("December 9, 2022"),
        title: "Christmas Toy Collection",
        location: "",
    },
    {
        allDay: false,
        start: new Date("December 17, 2022 10:00"),
        end: new Date("December 17, 2022"),
        title: "Christmas Toy Distribution",
        location: "",
    },
    {
        allDay: false,
        start: new Date("October 5, 2022 10:00"),
        end: new Date("October 5, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("October 12, 2022 10:00"),
        end: new Date("October 12, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("October 19, 2022 10:00"),
        end: new Date("October 19, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("October 26, 2022 10:00"),
        end: new Date("October 26, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("November 2, 2022 10:00"),
        end: new Date("November 2, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("November 9, 2022 10:00"),
        end: new Date("November 9, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("November 16, 2022 10:00"),
        end: new Date("November 16, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("November 23, 2022 10:00"),
        end: new Date("November 23, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("November 30, 2022 10:00"),
        end: new Date("November 30, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("December 7, 2022 10:00"),
        end: new Date("December 7, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("December 14, 2022 10:00"),
        end: new Date("December 14, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("December 21, 2022 10:00"),
        end: new Date("December 21, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("December 28, 2022 10:00"),
        end: new Date("December 28, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: false,
        start: new Date("February 16, 2022 10:00"),
        end: new Date("February 16, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: true,
        start: new Date("February 23, 2022 10:00"),
        end: new Date("February 23, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: true,
        start: new Date("March 2, 2022 10:00"),
        end: new Date("March 2, 2022"),
        title: "Fulton County Jail Facilitation",
        location: "",
    },
    {
        allDay: true,
        start: new Date("March 4, 2022 8:00"),
        end: new Date("March 4, 2022"),
        title: "PTSA MLK High Community Sponsor",
        location: "",
    },
    {
        allDay: true,
        start: new Date("March 19, 2022 11:00"),
        end: new Date("March 19, 2022"),
        title: "POH Community Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("April 8, 2022 12:00"),
        end: new Date("April 8, 2022"),
        title: "Extended Stay Job Workshop",
        location: "",
    },
    {
        allDay: false,
        start: new Date("July 2, 2021 12:00"),
        end: new Date("July 2, 2021"),
        title: "Extended Stay Job Workshop",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 16, 2021 12:00"),
        end: new Date("July 16, 2021"),
        title: "Extended Stay Job Workshop",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 24, 2021 12:00"),
        end: new Date("July 24, 2021"),
        title: "School Supply Distribution ",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 30, 2021 12:00"),
        end: new Date("July 30, 2021"),
        title: "Extended Stay Job Workshop ",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 18, 2021 12:00"),
        end: new Date("December 18, 2021"),
        title: "Christmas Holiday Gift Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 22, 2021 12:00"),
        end: new Date("June 22, 2021"),
        title: "Food Distribution Ray of Hope Christian Church",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 17, 2023 12:00"),
        end: new Date("June 17, 2023"),
        title: "Father's Day Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 2, 2023 12:00"),
        end: new Date("July 2, 2023"),
        title: "Tent Encampment Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("August 5, 2023 12:00"),
        end: new Date("August 5, 2023"),
        title: "Back to School Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 11, 2023 12:00"),
        end: new Date("November 11, 2023"),
        title: "Homeless Veterans Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 8, 2023 12:00"),
        end: new Date("December 10, 2023 12:00"),
        title: "Christmas and Holiday Gift Giveaway",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 6, 2023 12:00"),
        end: new Date("December 3, 2023 12:00"),
        title: "Holiday Gift Collection",
        location: "",
    },
    {
        allDay: true,
        start: new Date("February 14, 2024 12:00"),
        end: new Date("February 14, 2024"),
        title: "Valentine's Day Veteran Cupid boxes",
        location: "",
    },
    {
        allDay: true,
        start: new Date("March 24, 2024 12:00"),
        end: new Date("March 24, 2024"),
        title: "Tent City Easter Basket Giveaway",
        location: "",
    },
    {
        allDay: true,
        start: new Date("May 27, 2024 12:00"),
        end: new Date("May 27, 2024"),
        title: "Memorial Day Meal Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("August 3, 2024 12:00"),
        end: new Date("August 3, 2024"),
        title: "Backpack Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("September 26, 2024 12:00"),
        end: new Date("September 28, 2024 12:00"),
        title: "Fall Coat Collection Drive",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 31, 2024 12:00"),
        end: new Date("October 31, 2024"),
        title: "Halloween Food Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 1, 2024 12:00"),
        end: new Date("December 14, 2024 12:00"),
        title: "Gift Collection",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 23, 2024 10:00 AM"),
        end: new Date("November 23, 2024"),
        title: "Turkey Giveaway",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 21, 2024 11:00 AM"),
        end: new Date("December 21, 2024 1:00 PM"),
        title: "Gift Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 10, 2024 12:00"),
        end: new Date("October 10, 2024"),
        title: "Hurt Park - Backpack Distribution",
        location: "Hurt Park",
    },
    {
        allDay: true,
        start: new Date("March 1, 2025 12:00"),
        end: new Date("March 1, 2025"),
        title: "Women's History Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("April 1, 2025 12:00"),
        end: new Date("April 1, 2025"),
        title: "Autism Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("May 1, 2025 12:00"),
        end: new Date("May 1, 2025"),
        title: "Mental Health Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("May 26, 2025 12:00"),
        end: new Date("May 26, 2025"),
        title: "Honor Homeless Hero Giveaway",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 1, 2025 12:00"),
        end: new Date("June 1, 2025"),
        title: "LGBTQ+ Pride Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 19, 2025 12:00"),
        end: new Date("June 19, 2025"),
        title: "Juneteenth ",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 26, 2025 12:00"),
        end: new Date("July 26, 2025"),
        title: "Back 2 Skool Bash",
        location: "",
    },
    {
        allDay: true,
        start: new Date("September 1, 2025 12:00"),
        end: new Date("September 1, 2025"),
        title: "Suicide Prevention Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 1, 2025 12:00"),
        end: new Date("October 1, 2025"),
        title: "Cancer Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 31, 2025 12:00"),
        end: new Date("October 31, 2025"),
        title: "Boo-tiful Giving Family Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 1, 2025 12:00"),
        end: new Date("November 1, 2025"),
        title: "Diabetes Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 2, 2025 12:00"),
        end: new Date("December 2, 2025"),
        title: "Giving Tuesday",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 14, 2025 12:00"),
        end: new Date("December 14, 2025"),
        title: "Gifts of Hope Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 13, 2025 12:00"),
        end: new Date("December 13, 2025"),
        title: "Packing Party",
        location: "",
    },
    {
        allDay: true,
        start: new Date("January 19, 2026 12:00"),
        end: new Date("January 19, 2026"),
        title: "Dr. MLK Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("February 1, 2026 12:00"),
        end: new Date("February 1, 2026"),
        title: "Black History Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("February 16, 2026 12:00"),
        end: new Date("February 16, 2026"),
        title: "Presidents Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("February 21, 2026 12:00"),
        end: new Date("February 21, 2026 16:00"),
        title: "Hearts 4 Homeless Care Packages",
        location: "",
    },
    {
        allDay: true,
        start: new Date("March 1, 2026 12:00"),
        end: new Date("March 1, 2026"),
        title: "Women's History Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("March 28, 2026 12:00"),
        end: new Date("March 28, 2026"),
        title: "Volunteer with ACFB",
        location: "",
    },
    {
        allDay: true,
        start: new Date("April 1, 2026 12:00"),
        end: new Date("April 1, 2026"),
        title: "Autism Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("April 2, 2026 12:00"),
        end: new Date("April 2, 2026"),
        title: "Child Abuse Prevention Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("April 4, 2026 12:00"),
        end: new Date("April 4, 2026 16:00"),
        title: "Baskets of Hope Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("April 5, 2026 12:00"),
        end: new Date("April 5, 2026"),
        title: "Easter",
        location: "",
    },
    {
        allDay: true,
        start: new Date("April 22, 2026 12:00"),
        end: new Date("April 22, 2026"),
        title: "Earth Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("May 1, 2026 12:00"),
        end: new Date("May 1, 2026"),
        title: "Mental Health Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("May 10, 2026 12:00"),
        end: new Date("May 10, 2026"),
        title: "Mother's Day",
        location: "",
    },
    {
        allDay: false,
        start: new Date("May 23, 2026 12:00"),
        end: new Date("May 23, 2026 16:00"),
        title: "Jobs of Hope Career Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("May 25, 2026 12:00"),
        end: new Date("May 25, 2026"),
        title: "Memorial Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 1, 2026 12:00"),
        end: new Date("June 1, 2026"),
        title: "LGBTQ+ Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 19, 2026 12:00"),
        end: new Date("June 19, 2026"),
        title: "Juneteenth",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 21, 2026 12:00"),
        end: new Date("June 21, 2026"),
        title: "Father's Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("June 27, 2026 12:00"),
        end: new Date("June 27, 2026 16:00"),
        title: "Meals of Hope Cookout",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 1, 2026 12:00"),
        end: new Date("July 1, 2026"),
        title: "Disability Pride Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 4, 2026 12:00"),
        end: new Date("July 4, 2026"),
        title: "Independence Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("July 18, 2026 11:00"),
        end: new Date("July 18, 2026 14:00"),
        title: "Backpacks of Hope MS Delta",
        location: "",
    },
    {
        allDay: true,
        start: new Date("August 17, 2026 12:00"),
        end: new Date("August 17, 2026"),
        title: "National Nonprofits Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("August 26, 2026 12:00"),
        end: new Date("August 26, 2026"),
        title: "Women's Equality Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("September 1, 2026 12:00"),
        end: new Date("September 1, 2026"),
        title: "Suicide Prevention Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("September 11, 2026 12:00"),
        end: new Date("September 11, 2026 16:00"),
        title: "You Matter Care Kit Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("September 13, 2026 12:00"),
        end: new Date("September 13, 2026"),
        title: "Grandparents Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 1, 2026 12:00"),
        end: new Date("October 1, 2026"),
        title: "Cancer Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 10, 2026 12:00"),
        end: new Date("October 10, 2026"),
        title: "World Homeless Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("October 31, 2026 12:00"),
        end: new Date("October 31, 2026 16:00"),
        title: "Hope-O-Ween Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 1, 2026 12:00"),
        end: new Date("November 1, 2026"),
        title: "Diabetes Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 2, 2026 12:00"),
        end: new Date("November 2, 2026"),
        title: "Homeless/Housing Awareness Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 3, 2026 12:00"),
        end: new Date("November 3, 2026"),
        title: "Native American Heritage Month",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 11, 2026 12:00"),
        end: new Date("November 11, 2026"),
        title: "Veterans Day",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 14, 2026 12:00"),
        end: new Date("November 14, 2026 16:00"),
        title: "Hope in Coats Distribution",
        location: "",
    },
    {
        allDay: true,
        start: new Date("November 26, 2026 12:00"),
        end: new Date("November 26, 2026"),
        title: "Thanksgiving",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 1, 2026 12:00"),
        end: new Date("December 1, 2026"),
        title: "Giving Tuesday",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 19, 2026 12:00"),
        end: new Date("December 19, 2026"),
        title: "Gifts of Hope",
        location: "",
    },
    {
        allDay: true,
        start: new Date("December 25, 2026 12:00"),
        end: new Date("December 25, 2026"),
        title: "Christmas",
        location: "",
    },
];
